import { useEffect, useState } from "react";

/**
 * A ticking clock. The kiosk shows one because an idle screen with a live clock
 * reads as "working"; a frozen one reads as "crashed" from across the lobby.
 *
 * Ticks are aligned to the wall-clock second so the display never sits a beat
 * behind after the tab has been backgrounded.
 */
export function useClock(intervalMs = 1000): Date {
  const [now, setNow] = useState(() => new Date());

  useEffect(() => {
    let timeout = 0;
    const tick = () => {
      setNow(new Date());
      const drift = Date.now() % intervalMs;
      timeout = window.setTimeout(tick, intervalMs - drift);
    };
    timeout = window.setTimeout(tick, intervalMs - (Date.now() % intervalMs));
    return () => window.clearTimeout(timeout);
  }, [intervalMs]);

  return now;
}

/**
 * "4:05 PM  ·  Thursday, 25 September" — the idle line under the scan and find
 * screens, in the device's own locale.
 */
export function clockLine(now: Date): string {
  const time = now.toLocaleTimeString(undefined, { hour: "numeric", minute: "2-digit" });
  const date = now.toLocaleDateString(undefined, {
    weekday: "long",
    day: "numeric",
    month: "long",
  });
  return `${time}  ·  ${date}`;
}
